import { getTrasladoEstadoColor } from "../../../../../constants/trasladosEstados";
import { StyledTraslados } from "../../../../styled/traslados";

const formatPorcentajeTramos = (cantidad, totalTramos) => {
  const total = Number(totalTramos);
  const value = Number(cantidad);
  if (!Number.isFinite(total) || total <= 0 || !Number.isFinite(value)) {
    return null;
  }

  return ((value / total) * 100).toLocaleString("es-AR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
};

const ReportesChartTooltip = ({
  color,
  label,
  fecha,
  cantidad,
  cantidadLabel = "Cantidad",
  porcentajeTramos,
  symbol = "circle",
}) => (
  <StyledTraslados.ChartTooltip>
    <StyledTraslados.ChartTooltipHeader>
      <StyledTraslados.ChartLegendSwatch
        symbol={symbol}
        swatchColor={color}
      />
      <StyledTraslados.ChartTooltipTitle>{label}</StyledTraslados.ChartTooltipTitle>
    </StyledTraslados.ChartTooltipHeader>
    {fecha ? (
      <StyledTraslados.ChartTooltipLine>
        Fecha: {fecha}
      </StyledTraslados.ChartTooltipLine>
    ) : null}
    <StyledTraslados.ChartTooltipLine>
      {cantidadLabel}: {cantidad}
    </StyledTraslados.ChartTooltipLine>
    {porcentajeTramos != null ? (
      <StyledTraslados.ChartTooltipLine>
        Porcentaje de tramos: {porcentajeTramos}%
      </StyledTraslados.ChartTooltipLine>
    ) : null}
  </StyledTraslados.ChartTooltip>
);

const getPointLabel = (point) => point.seriesId ?? point.serieId ?? point.id;

const getPointFecha = (point) => point.data?.xFormatted ?? point.data?.x;

const getOverlappingSeries = (series = [], fecha, cantidad) => {
  if (!Number.isFinite(cantidad) || cantidad === 0) return [];

  return series
    .map((serie) => {
      const label = serie.id ?? serie.art;
      const match = (serie.data || []).find((item) => item.x === fecha);
      if (!match || Number(match.y) !== cantidad) return null;
      return {
        id: label,
        label,
        color: getTrasladoEstadoColor(label),
        cantidad: Number(match.y),
      };
    })
    .filter(Boolean);
};

const ReportesOverlapTooltip = ({ fecha, points }) => (
  <StyledTraslados.ChartTooltip>
    {fecha ? (
      <StyledTraslados.ChartTooltipLine>
        Fecha: {fecha}
      </StyledTraslados.ChartTooltipLine>
    ) : null}
    {points.map((point) => (
      <StyledTraslados.ChartTooltipSliceRow key={point.id}>
        <StyledTraslados.ChartLegendSwatch
          symbol="circle"
          swatchColor={point.color}
        />
        <StyledTraslados.ChartTooltipSliceName>
          {point.label}
        </StyledTraslados.ChartTooltipSliceName>
        <StyledTraslados.ChartTooltipSliceValue>
          {point.cantidad}
        </StyledTraslados.ChartTooltipSliceValue>
      </StyledTraslados.ChartTooltipSliceRow>
    ))}
  </StyledTraslados.ChartTooltip>
);

export const ReportesLineTooltip = (props) => {
  const point = props.point ?? props;
  const label = getPointLabel(point);
  const color =
    point.seriesColor ??
    point.serieColor ??
    point.color ??
    getTrasladoEstadoColor(label);
  const fecha = getPointFecha(point);
  const overlapping = getOverlappingSeries(
    props.series,
    fecha,
    Number(point.data?.y),
  );
  const points =
    overlapping.length >= 2
      ? overlapping
      : [
          {
            id: label,
            label,
            color,
            cantidad: point.data?.yFormatted ?? point.data?.y,
          },
        ];

  return <ReportesOverlapTooltip fecha={fecha} points={points} />;
};

export const createReportesLineTooltip = (series = []) => (props) => (
  <ReportesLineTooltip {...props} series={series} />
);

export const createReportesBarTooltip = (totalTramos) => (bar) => {
  const label = bar.indexValue ?? bar.id;
  const color = bar.color ?? getTrasladoEstadoColor(label);
  const cantidad = bar.formattedValue ?? bar.value;

  return (
    <ReportesChartTooltip
      color={color}
      label={label}
      cantidad={cantidad}
      cantidadLabel="Tramos"
      porcentajeTramos={formatPorcentajeTramos(cantidad, totalTramos)}
      symbol="square"
    />
  );
};

export default ReportesChartTooltip;
